module.exports = __webpack_public_path__ + "5fcc41db42ed3507c603446b29492561.svg";